import React, { useState } from 'react';
import { API } from '../App';

const SAMPLE_MT700 = `{1:F01DEUTDEDBAXXX0000000000}{2:I700BNPAFRPPXXXXN}{4:
:20:LC-2026-03-001
:27:1/1
:40A:IRREVOCABLE
:20:LC2026Q1CRUDE
:31C:260327
:31D:260630ROTTERDAM
:32B:USD5000000,
:39A:5/5
:41D:ANY BANK IN ROTTERDAM
BY NEGOTIATION
:42C:DRAFTS AT SIGHT
:43P:NOT ALLOWED
:43T:NOT ALLOWED
:44E:RAS TANURA, SAUDI ARABIA
:44F:ROTTERDAM, NETHERLANDS
:44C:260510
:45A:50,000 MT +/-5% OF CRUDE OIL D6
SPECIFICATION AS PER CONTRACT NO. EC-2026-001
CIF ROTTERDAM
:46A:FULL SET CLEAN ON BOARD BILLS OF LADING
COMMERCIAL INVOICE IN TRIPLICATE
CERTIFICATE OF ORIGIN
SGS QUALITY AND QUANTITY CERTIFICATE
INSURANCE CERTIFICATE
:47A:DOCUMENTS MUST BE PRESENTED WITHIN 21 DAYS
OF BILL OF LADING DATE
:48:21
:49:CONFIRM
:50:ENERGY CONSULTING BPOS GMBH
MUSTERSTRASSE 1
10115 BERLIN, GERMANY
:59:SAUDI ARAMCO TRADING CO
PO BOX 5000
DHAHRAN 31311, SAUDI ARABIA
:71B:ALL BANKING CHARGES OUTSIDE GERMANY
ARE FOR ACCOUNT OF BENEFICIARY
:78:DOCUMENTS TO BE FORWARDED TO ISSUING BANK
IN ONE LOT BY COURIER
-}`;

export default function SwiftParserPage() {
  const [input, setInput]   = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoad]  = useState(false);
  const [err, setErr]       = useState('');
  const [tab, setTab]       = useState('parser'); // 'parser' | 'reference'
  const [fieldRef, setFieldRef] = useState(null);

  const parse = async () => {
    if (!input.trim()) { setErr('Nachricht eingeben'); return; }
    setLoad(true); setErr(''); setResult(null);
    try {
      const r = await API.post('/swift-parser/parse', { message: input });
      setResult(r.data.parsed);
    } catch (e) {
      setErr(e.response?.data?.detail || 'Parse-Fehler');
    } finally { setLoad(false); }
  };

  const loadFieldRef = async () => {
    if (fieldRef) { setTab('reference'); return; }
    const r = await API.get('/swift-parser/field-reference');
    setFieldRef(r.data);
    setTab('reference');
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <h1>📨 SWIFT Parser</h1>
        <p>MT700 / MT760 / MT707 — Nachrichtenparser & Feldanalyse</p>
      </div>

      <div style={{ padding:'12px 16px', marginBottom:20, borderRadius:8,
        background:'#8b5cf615', border:'1px solid #8b5cf640', fontSize:13, color:'#8b5cf6' }}>
        ℹ Parser-Framework: Analysiert SWIFT-Nachrichtenfelder lokal. Für vollständige Validierung und
        Bank-Connectivity ist SWIFT Alliance Gateway / FileAct erforderlich.
      </div>

      {/* Tab Bar */}
      <div style={{ display:'flex', gap:4, borderBottom:'1px solid var(--border)', marginBottom:20 }}>
        {[
          { id:'parser', label:'🔍 Parser' },
          { id:'reference', label:'📋 Feldreferenz' },
        ].map(t => (
          <button key={t.id} onClick={() => t.id === 'reference' ? loadFieldRef() : setTab('parser')}
            className="btn btn-ghost btn-sm"
            style={{ borderBottom: tab === t.id ? '2px solid var(--accent)' : '2px solid transparent',
              borderRadius:'6px 6px 0 0', color: tab === t.id ? 'var(--accent)' : 'var(--text2)' }}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'parser' && (
        <div className="grid-2" style={{ alignItems:'start' }}>
          <div>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
              <label className="form-label" style={{ margin:0 }}>SWIFT Nachricht (MT700/MT760/…)</label>
              <button className="btn btn-ghost btn-sm" onClick={() => setInput(SAMPLE_MT700)}>
                Beispiel laden
              </button>
            </div>
            <textarea
              className="form-input"
              rows={20}
              style={{ fontFamily:'monospace', fontSize:12, resize:'vertical' }}
              value={input}
              onChange={e => setInput(e.target.value)}
              placeholder="Hier SWIFT-Nachricht einfügen…"
            />
            {err && <div className="error-msg" style={{ marginTop:8 }}>{err}</div>}
            <button className="btn btn-primary" style={{ marginTop:10 }} onClick={parse} disabled={loading}>
              {loading ? 'Analysiere…' : '🔍 Analysieren'}
            </button>
          </div>

          <div>
            {result && (
              <div>
                <div className="card" style={{ marginBottom:12 }}>
                  <div className="card-title">Nachrichtentyp</div>
                  {result.mt_type && (
                    <div style={{ fontSize:15, fontWeight:700, color:'var(--accent)', marginBottom:4 }}>
                      MT{result.mt_type}
                    </div>
                  )}
                  {result.mt_name && (
                    <div style={{ fontSize:13, color:'var(--text2)' }}>{result.mt_name}</div>
                  )}
                  {result.sender_bic && (
                    <div style={{ fontSize:12, color:'var(--text3)', marginTop:6 }}>
                      Sender BIC: <code>{result.sender_bic}</code>
                    </div>
                  )}
                  <div style={{ fontSize:12, color:'var(--text3)', marginTop:4 }}>
                    {result.field_count} Felder erkannt
                  </div>
                </div>

                <div className="card">
                  <div className="card-title">Erkannte Felder</div>
                  <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                    {Object.values(result.fields).map(f => (
                      <div key={f.tag} style={{ padding:'8px 10px', background:'var(--bg-surface)',
                        borderRadius:6, borderLeft:`3px solid var(--accent)` }}>
                        <div style={{ display:'flex', gap:8, alignItems:'baseline', marginBottom:4 }}>
                          <code style={{ fontSize:12, fontWeight:700, color:'var(--accent)' }}>:{f.tag}:</code>
                          <span style={{ fontSize:11, color:'var(--text3)' }}>{f.name}</span>
                        </div>
                        <div style={{ fontSize:12, color:'var(--text1)', whiteSpace:'pre-wrap', fontFamily:'monospace' }}>
                          {f.value}
                        </div>
                      </div>
                    ))}
                    {result.field_count === 0 && (
                      <div style={{ fontSize:13, color:'var(--text3)' }}>
                        Keine Felder erkannt — prüfe das Nachrichtenformat.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {!result && !loading && (
              <div style={{ padding:'60px 0', textAlign:'center', color:'var(--text3)' }}>
                <div style={{ fontSize:40, marginBottom:12 }}>📨</div>
                <div style={{ fontSize:14 }}>SWIFT Nachricht einfügen und analysieren</div>
              </div>
            )}
          </div>
        </div>
      )}

      {tab === 'reference' && fieldRef && (
        <div>
          <div style={{ marginBottom:24 }}>
            <div className="card-title" style={{ marginBottom:12 }}>MT-Nachrichtentypen (Dokumenten-Akkreditive)</div>
            <div className="grid-2">
              {Object.entries(fieldRef.mt_types).map(([k, v]) => (
                <div key={k} style={{ display:'flex', gap:12, padding:'6px 0', borderBottom:'1px solid var(--border)', fontSize:13 }}>
                  <code style={{ color:'var(--accent)', fontWeight:700, minWidth:40 }}>MT{k}</code>
                  <span style={{ color:'var(--text2)' }}>{v}</span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="card-title" style={{ marginBottom:12 }}>Feldreferenz (MT700 / MT760 Subset)</div>
            <div className="grid-2">
              {Object.entries(fieldRef.fields).map(([k, v]) => (
                <div key={k} style={{ display:'flex', gap:12, padding:'6px 0', borderBottom:'1px solid var(--border)', fontSize:13 }}>
                  <code style={{ color:'var(--accent)', fontWeight:700, minWidth:40 }}>:{k}:</code>
                  <span style={{ color:'var(--text2)' }}>{v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
